'use strict';

var StrategyActionDataService = function StrategyActionDataService(strategyRecordDataService) {
  var mapping = require('./../config/action-data-mapping');
  function getOperandData(fieldId) {
    return strategyRecordDataService.getOperandData(mapping, fieldId);
  }
  return {
    getOperandData: getOperandData
  };
};
StrategyActionDataService.$inject = ['StrategyRecordDataService'];
module.exports = StrategyActionDataService;